import { CumulativeHoldingQuickRound } from "./CapTable";
import { QuickBonusTransactionDetails } from "./quickRound";
import {
  BuybackTransaction,
  PrimaryTransaction,
  SecondaryTransaction,
} from "../pages/newQuickTransaction/RoundTransactionModel";

interface Transactions {
  primaryTransactions: PrimaryTransaction[];
  quickBonusTransactions?: QuickBonusTransactionDetails[];
  quickBuybackParticipants?: BuybackTransaction[];
  secondaryTransactions?: SecondaryTransaction[];
  split: SplitTransaction;
  esopPostRoundPercentage: number;
  type?: string;
  antiDilutionSecurities?: AntiDilutionSecurity[];
  reverseSplit?: SplitTransaction;
}

interface SplitTransaction {
  date: string;
  securityType: string;
  splitName: string;
  splitRatio: number;
}

interface EventInfo {
  pps: number;
  date: string;
  name: string;
  valuation: number;
  pricedRound: boolean;
  allotmentType: string;
  issuanceType: string;
  paymentType: string;
  roundIdentifier: string;
  ratio: number;
  type: string;
  bonusRatio?: string;
  applicableToAllSecurities?: string;
}

export interface PreviewQuickRoundResponseModel {
  holdingDifference?: CumulativeHoldingQuickRound[];
  transactions?: Transactions;
  eventInfo?: EventInfo;
  preEventFdb: number;
  preEventvaluation: number;
  postEventEsop: number;
  preEventPps: number;
  eventDate?: string;
}

export type InvestorDetails = {
  investorId: string;
  investorName: string;
  numberOfShares?: number;
  additionalShares?: number;
  finalFdbShares?: number;
  allocationMethod?: string;
}

export interface AntiDilutionSecurity {
  allocationMethod?: string;
  investorId?: string;
  instrumentClassId: string;
  adjustedPrice?: number;
  useConversionRatio: boolean;
  antiDilutionShares?: number;
  ratio?: number;
  investorDetails: InvestorDetails[];
  antiDilutionMethod?: string;
}

export enum AntiDilutionAllocationType {
  None = "None",
  UpdateConversionRatio = "Update Conversion Ratio",
  IssueShares = "Issue Shares"
}
export interface IAntiDilutionInput {
  antiDilutionSecurities: AntiDilutionSecurity[];
  eventId: string;
}

export interface AntiDilutionShareholder extends InvestorDetails {
  allocationMethod?: string;
  adjustedPrice: number;
  useConversionRatio: boolean;
  instrumentClassId: string;
  ratio?: number;
}
